import { useCallback } from 'react';

import { requestBuilder } from '../../../http/RequestBuilder';
import type { User } from '../../../user/types/User';

interface CreateMemberBody {
    customerId: string;
    email: string;
    stytchId: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    guideSignUpId?: string;
    dateOfBirth?: string; // ISO date (YYYY-MM-DDT00:00:00Z)
    referralCode?: string;
    visitorId?: string;
}

interface CreateMemberParams extends CreateMemberBody {
    onSuccess: (user: User) => void;
    onError: (error: Error) => void;
}

const useMutateMember = requestBuilder.mutation<User, CreateMemberBody>({
    endpoint: '/api/user/member',
    method: 'POST',
});

export const useCreateMember = () => {
    const { mutate, isPending } = useMutateMember();

    const createMember = useCallback(
        ({
            customerId,
            email,
            stytchId,
            firstName,
            lastName,
            phoneNumber,
            guideSignUpId,
            dateOfBirth,
            referralCode,
            visitorId,
            onSuccess,
            onError,
        }: CreateMemberParams) => {
            mutate(
                {
                    body: {
                        customerId,
                        email,
                        stytchId,
                        firstName,
                        lastName,
                        phoneNumber,
                        guideSignUpId,
                        dateOfBirth,
                        referralCode,
                        visitorId,
                    },
                },
                {
                    onSuccess,
                    onError,
                },
            );
        },
        [],
    );

    return { createMember, isCreatingMember: isPending };
};
